/**
 * Theme/storefront reference only — NOT loaded by the F32 Shopify app.
 * GFB (Frequently Bought) bundle UI redesign (Kaching-style).
 * Paste into theme Custom Liquid / asset when needed.
 */
(function() {
  'use strict';

  // Prevent simultaneous rebuilds
  let isRebuilding = false;
  let rebuildTimeout = null;

  // Switch to `true` for production (or just delete the URL check)
  //const USE_V2_BADGE = new URLSearchParams(window.location.search).get('dev') === '1';
  const USE_V2_BADGE = true;

  function getHardnessBadge(valueName) {
    const fallbackTags = {
      soft_tag: 'GENTLE',
      medium_tag: 'JUST RIGHT',
      hard_tag: 'INTENSE'
    };
    
    const metaTags = (window.productMetafields && window.productMetafields.hardnessDescriptions) || fallbackTags;
    
    const softVariations = ['Soft', 'Mehka', 'Mekana', 'Mehke', 'Mekane', 'Miękki', 'Měkký', 'Mäkký', 'Miękkie', 'Mäkká'];
    const mediumVariations = ['Medium', 'Srednja', 'Srednje', 'Średni', 'Střední', 'Stredný', 'Średnie', 'Stredná'];
    const hardVariations = ['Hard', 'Trda', 'Trde', 'Tvrda', 'Tvrde', 'Twardy', 'Tvrdý', 'Twarde', 'Tvrdá'];
    
    if (softVariations.includes(valueName)) {
      return metaTags.soft_tag || fallbackTags.soft_tag;
    } else if (mediumVariations.includes(valueName)) {
      return metaTags.medium_tag || fallbackTags.medium_tag;
    } else if (hardVariations.includes(valueName)) {
      return metaTags.hard_tag || fallbackTags.hard_tag;
    }
    
    return '';
  }

  function getHardcodedColorSwatch(valueName) {
    const greenVariations = ['Green', 'Zelena', 'Zielony', 'Zelená', 'Zelený'];
    const blackVariations = ['Black', 'Črna', 'Crna', 'Czarny', 'Černá', 'Čierny', 'Čierna'];
    const redVariations = ['Red', 'Rdeča', 'Crvena', 'Czerwony', 'Červená', 'Červený'];
    const grayVariations = ['Gray', 'Siva', 'Szary', 'Šedá', 'Sivý', 'Sivá'];
    const yellowVariations = ['Yellow', 'Rumena', 'Žuta', 'Żółty', 'Žluť', 'Žltý', 'Žlutá', 'Žltá'];
    const purpleVariations = ['Purple', 'Vijolična', 'Ljubičasta', 'Fioletowy', 'Fialová', 'Fialový'];

    if (greenVariations.includes(valueName)) {
      return 'rgb(153, 229, 178)';
    } else if (blackVariations.includes(valueName)) {
      return 'rgb(0, 0, 0)';
    } else if (redVariations.includes(valueName)) {
      return 'rgb(248, 89, 103)';
    } else if (grayVariations.includes(valueName)) {
      return 'rgb(189, 188, 188)';
    } else if (yellowVariations.includes(valueName)) {
      return 'rgb(242, 230, 0)';
    } else if (purpleVariations.includes(valueName)) {
      return 'rgb(129, 0, 185)';
    }

    return null;
  }

  const normalizeImageUrl = (url) => {
    if (!url) return '';
    return url.startsWith('//') ? `https:${url}` : url;
  };

  /** Parse theme money strings ("39,90€", "48.50") into a number. */
  function parseMoneyAmount(value) {
    if (value == null || value === '') return Number.NaN;
    if (typeof value === 'number') return value;
    const raw = String(value).replace(/[^\d,.\-]/g, '').trim();
    if (!raw) return Number.NaN;
    if (raw.includes(',') && raw.includes('.')) {
      return Number.parseFloat(raw.replace(/\./g, '').replace(',', '.'));
    }
    if (raw.includes(',')) {
      return Number.parseFloat(raw.replace(',', '.'));
    }
    return Number.parseFloat(raw);
  }

  /**
   * Theme often floors discount_percentage (17.73 → 17).
   * Recalculate from compare/sale and Math.round so it matches F32 cards (→ 18).
   */
  function getRoundedDiscountPercent(pricing) {
    if (!pricing) return 0;

    const sale = parseMoneyAmount(pricing.price);
    const compare = parseMoneyAmount(pricing.compare_at_price);
    if (
      Number.isFinite(compare) &&
      Number.isFinite(sale) &&
      compare > sale &&
      compare > 0
    ) {
      return Math.round(((compare - sale) / compare) * 100);
    }

    const fallback = Number.parseFloat(String(pricing.discount_percentage || ''));
    if (!Number.isFinite(fallback) || fallback <= 0) return 0;
    return Math.round(fallback);
  }

  function injectStyles() {
    if (document.getElementById('gfb-redesign-styles')) return;
    
    // Reuse the exact same styles from Kaching bundles
    const style = document.createElement('style');
    style.id = 'gfb-redesign-styles';
    style.textContent = `
      .gfbPageWrapper {
        opacity: 0 !important;
        transition: opacity 0.4s ease !important;
      }
      
      .gfbPageWrapper.gfb-ready {
        opacity: 1 !important;
      }
      
      .gfb-redesigned {
        background: #F5F5F5 !important;
        border-radius: 16px !important;
      }
      
      /* Hide original GFB content */
      .gfb-redesigned .gfbFrequentBoughtReplacableContent {
        display: none !important;
      }
      
      .gfb-redesigned .gfbFrequentBoughtWidgetTitleContainer {
        display: none !important;
      }
      
      /* Custom price section */
      .kb-price-section {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-top: 8px;
    }
      
      .kb-price-label {
        display: none;
      }
      
      .kb-price-values {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      
      .kb-price-compare {
        font-size: 18px;
        font-weight: 700;
        color: #a000ff;
        font-family: var(--font-rubik-family);
        position: relative;
      }
      
      .kb-price-compare::after {
        content: '';
        position: absolute;
        left: -2px;
        right: -2px;
        top: 50%;
        height: 2px;
        background: #a000ff;
        transform: translateY(-50%) rotate(-8deg);
        transform-origin: center;
      }
      
      .kb-price-current {
        font-size: 18px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        font-family: var(--font-rubik-family);
      }
      
      .kb-price-discount {
        padding: 2px 8px;
        border-radius: 24px;
        background: #a000ff;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-family: var(--font-rubik-family);
      }
      
      /* Choose Options label and header */
      .kb-options-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        border-top: 1px solid rgba(65, 64, 66, 0.2);
        padding-top: 12px;
      }
      
      .kb-choose-options-label {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        margin-right: 12px;
      }
      
      .kb-bristle-info-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        background: rgba(65, 64, 66, 0.1);
        border: none;
        border-radius: 24px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
        color: rgba(65, 64, 66, 0.8);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        transition: all 0.2s ease;
      }
      
      .kb-bristle-info-btn:hover {
        background: rgba(65, 64, 66, 0.15);
      }
      
      .kb-bristle-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: none;
        align-items: center;
        justify-content: center;
        z-index: 100000;
        padding: 20px;
      }
      
      .kb-bristle-modal-overlay.open {
        display: flex;
      }
      
      .kb-bristle-modal {
        background: white;
        border-radius: 24px;
        max-width: 303px;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        padding: 16px;
        position: relative;
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      
      .kb-bristle-modal::-webkit-scrollbar {
        display: none;
      }
      
      .kb-bristle-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 2px solid rgba(65, 64, 66, 0.1);
      }
      
      .kb-bristle-modal-title {
        font-size: 20px;
        font-weight: 800;
        color: #a000ff;
        text-transform: uppercase;
        letter-spacing: -0.5px;
        line-height: 1.2;
        font-family: var(--font-rubik-family);
      }
      
      .kb-bristle-modal-close {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background 0.2s ease;
      }
      
      .kb-bristle-modal-close:hover {
        background: rgba(139, 86, 255, 0.1);
      }
      
      .kb-bristle-option-section {
        border-bottom: 1px solid rgba(65, 64, 66, 0.2);
        padding-bottom: 16px;
      }
      
      .kb-bristle-option-section:last-child {
        margin-bottom: 0;
        border-bottom: none;
        padding-bottom: 0;
      }

      .kb-bristle-option-section:not(:first-child) {
        margin-top: 16px;
      }
      
      .kb-bristle-option-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 8px;
      }
      
      .kb-bristle-option-image {
        width: 60px;
        height: 60px;
        object-fit: contain;
        border-radius: 8px;
        background: rgba(65, 64, 66, 0.05);
        flex-shrink: 0;
      }
      
      .kb-bristle-option-title-group {
        flex: 1;
      }
      
      .kb-bristle-option-name {
        font-size: 22px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        margin-bottom: 0;
        line-height: .5;
      }
      
      .kb-bristle-option-badge {
        display: inline-block;
        padding: 0px 10px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        min-width: 72px;
        text-align: center;
      }
      
      .kb-bristle-option-subtitle {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        margin-top: -4px;
      }
      
      .kb-bristle-option-description {
        font-size: 12px;
        color: rgba(65, 64, 66, 0.6);
        line-height: 1.6;
      }
      
      /* Use Kaching bundle styles */
      .kb-variants-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(65, 64, 66, 0.2);
      }
      
      /* Black Friday Badge v2 - top (dark) */
      .kb-black-friday-badge-top {
        display: flex;
        width: fit-content;
        margin: 0 auto 16px;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 8px 12px;
        background: #00EBBE;
        border-radius: 50px; 
      }


      .kb-black-friday-badge-top .kb-bf-text-1, .kb-black-friday-badge-top .kb-bf-text-2{
        color: #005242!important;
      } 


      .kb-black-friday-badge-top .kb-bf-text-1{
        font-weight: 400!important;
      }

      /* Black Friday Badge */
      .kb-black-friday-badge {
        display: flex;
        width: fit-content;
        margin: 0 auto;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 8px 12px;
        /*background: linear-gradient(90deg, #414042 0%, #111111 100%);*/
        /*background: linear-gradient(90deg, #F95DFF 0%, #A000FF 100%);*/
        background: #a000ff;
        border-radius: 50px;
        margin-top: 16px;
        margin-bottom: 0px;
      }
      
      .kb-bf-text-1 {
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: rgb(0, 235, 190);

      }
      
      .kb-bf-text-2 {
        font-weight: 700;
        font-style: Bold;
        line-height: 120%;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #FFFFFF;

      }
      
      .kb-variant-card {
        display: flex;
        align-items: end;
        gap: 12px;
        border-radius: 12px;
      }
      
      .kb-variant-image {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 12px;
        flex-shrink: 0;
        background-color: #FFFFFF !important;
      }
      
      .kb-selectors-row {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1;
      }
      
      .kb-option-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 0px;
        flex: 1;
      }
      
      .kb-option-label {
        font-size: 12px;
        font-weight: 500;
        color: rgba(65, 64, 66, 0.6);
        line-height: 1.3;
      }
      
      .kb-trigger-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        border-width: 2px;
        padding-top: 8px;
        padding-right: 4px;
        padding-bottom: 8px;
        padding-left: 16px;
        border-radius: 16px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s ease, background 0.2s ease;
      }
      
      .kb-trigger-button:hover {
        border-color: rgba(0,0,0,0.3);
      }
      
      .kb-trigger-left {
        display: flex;
        gap: 2px;
        text-align: left;
        flex-direction: column;
        align-items: flex-start;
      }
      
      .kb-swatch-display {
        display: none;
        width: 72px;
        height: 18px;
        border-radius: 24px;
      }
      
      .kb-swatch-display.visible {
        display: inline-block;
      }
      
      .kb-swatch-display.has-image {
        width: 36px;
        height: 36px;
        border-radius: 6px;
      }
      
      .kb-value-display {
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-ingredient-bold {
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-ingredient-normal {
        font-weight: 400;
        color: rgba(65, 64, 66, 0.6);
      }
      
      .kb-caret {
        font-size: 0px;
        color: rgba(0,0,0,0.45);
      }
      
      .kb-dropdown {
        display: none;
        position: absolute;
        top: calc(100% + 6px);
        left: -80px;
        right: 0;
        background: #fff;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        padding: 6px;
        z-index: 10000;
        overflow-y: auto;
        box-shadow: 0px 4px 6px 0px rgba(65, 64, 66, 0.2);
      }
      
      .kb-dropdown.open {
        display: block;
      }

      .kb-dropdown.kb-dropdown-hardness-option {
        left: 0 !important;
        padding: 8px !important;
      }
      
      .kb-option-row {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0px;
        border-radius: 12px;
        border: none;
        background: transparent;
        cursor: pointer;
        text-align: left;
        transition: background 0.15s ease;
        margin-bottom: 5px;
      }

      .kb-dropdown-hardness-option .kb-option-row{
        padding: 8px !important;
      }

      .kb-dropdown-hardness-option .kb-option-row:last-of-type{
        margin-bottom: 0px !important;
      }
      
      .kb-option-row:hover {
        background: rgba(0,0,0,0.04);
      }
      
      .kb-option-row.selected {
        background: rgba(244, 244, 244, 1);
      }
      
      .kb-option-row-wrapper {
        display: flex;
        align-items: center;
        gap: 14px;
        flex: 1;
      }
      
      .kb-option-preview {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 12px;
        background-color: #f4f4f4 !important;
        flex-shrink: 0;
      }
      
      .kb-option-detail {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      
      .kb-row-swatch {
        display: inline-block;
        width: 64px;
        height: 12px;
        border-radius: 6px;
      }
      
      .kb-row-label {
        font-size: 13px;
        font-weight: 600;
        color: #000;
      }
      
      .kb-hardness-row {
        display: flex;
        flex-direction: column;
        gap: 2px;
        width: 100%;
      }
      
      .kb-hardness-value {
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-hardness-badge {
        display: inline-block;
        padding: 2px 0px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        align-content: center;
        text-align: center;
      }
      
      .kb-hardness-badge-trigger {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }

      .gfbFrequentBoughtAddToCartButtonSection .gfbFrequentBoughtAddToCartButton{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 14px 28px;
            border-radius: 50px;
            font-size: 0.875em;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            text-decoration: none;
            transition: transform 0.2s ease, opacity 0.2s ease;
            position: relative;
            font-family: var(--font-rubik-family);
            background: #00EBBE;
            color: #005242;
            margin-top: 20px;
      }
      
      .gfbFrequentBoughtAddToCartButton::after {
        content: '';
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 15L12.5 10L7.5 5' stroke='%23005242' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      
      @media (max-width: 768px) {
        .gfb-redesigned {
          padding: 0px !important;
        }

         .kb-black-friday-badge{
         display: block;
         }
        
        .kb-trigger-button {
          gap: 0px !important;
          padding-left: 8px !important;
        }

        .kb-selectors-row, .kb-variant-card {
          gap: 6px !important;
        }

        .kb-variant-card {
          font-size: 12px;
        }

        .kb-hardness-badge-trigger {
          padding: 4px 6px !important;
          font-size: 8px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function redesignGFBBundles() {
    injectStyles(); // Always inject styles first
    
    const allPageWrappers = document.querySelectorAll('.gfbPageWrapper');
    const wrapper = document.querySelector('.gfbPageWrapper .gfbFrequentBoughtWrapper');
    
    if (!wrapper) {
      // Show all wrappers even if we're not redesigning
      allPageWrappers.forEach(pageWrapper => {
        pageWrapper.style.display = 'block';
        requestAnimationFrame(() => {
          pageWrapper.classList.add('gfb-ready');
        });
      });
      return;
    }
    
    // Prevent simultaneous rebuilds
    if (isRebuilding) {
      return;
    }
    
    isRebuilding = true;
    
    // Remove any existing custom UI containers from previous rebuild
    const existingCustomContainer = wrapper.querySelector('.kb-custom-ui-container');
    if (existingCustomContainer) {
      existingCustomContainer.remove();
    }
    
    wrapper.classList.add('gfb-redesigned');

    const closeAllDropdowns = () => {
      wrapper.querySelectorAll('.kb-dropdown').forEach((dropdown) => {
        dropdown.classList.remove('open');
      });
    };

    if (!document.body.dataset.gfbDropdownListener) {
      document.addEventListener('click', closeAllDropdowns);
      document.body.dataset.gfbDropdownListener = 'true';
    }

    // Parse products from the DOM
    const products = wrapper.querySelectorAll('.gfbFrequentBoughtWidgetProductContainer');
    const productsData = [];
    
    // Get GFB bundle product data for availability checking
    const gfbBundleData = window.gfbFrequentBought?.state?.frequentBoughtShopifyData || [];
    
    products.forEach((product, productIndex) => {
      const variantContainer = product.querySelector('.gfbFrequentBoughtVariantUIParentContainer');
      if (!variantContainer || variantContainer.children.length === 0) return; // Skip products without variants
      
      const imageEl = product.querySelector('.gfbFrequentBoughtWidgetProductImageEle');
      const image = imageEl ? normalizeImageUrl(imageEl.src) : '';
      
      // Extract quantity from product title (e.g., "Remineralizing toothpaste x8" -> "8")
      const titleEl = product.querySelector('.gfbFrequentBoughtWidgetProductTitle');
      const titleText = titleEl ? titleEl.textContent.trim() : '';
      const qtyMatch = titleText.match(/x(\d+)$/i);
      const quantity = qtyMatch ? qtyMatch[1] : null;
      
      // Get the corresponding GFB product data (match by index in the bundle)
      const gfbProduct = gfbBundleData[productIndex] || null;
      
      const dropdowns = product.querySelectorAll('.gfbFrequentBoughtSingleDropdownContainer');
      const options = [];
      
      // First pass: get currently selected values for this product
      const currentSelections = {};
      dropdowns.forEach(dropdownContainer => {
        const heading = dropdownContainer.querySelector('.gfbFrequentBoughtSingleDropdownHeading');
        const dropdown = dropdownContainer.querySelector('.gfbDropdown');
        if (!heading || !dropdown) return;
        
        const optName = heading.textContent.trim();
        const selectedInput = dropdown.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          const selectedSpan = selectedInput.closest('.gfbDropdownMenuItem')?.querySelector('span');
          if (selectedSpan) {
            currentSelections[optName] = selectedSpan.textContent.trim();
          }
        }
      });
      
      dropdowns.forEach(dropdownContainer => {
        const heading = dropdownContainer.querySelector('.gfbFrequentBoughtSingleDropdownHeading');
        const dropdown = dropdownContainer.querySelector('.gfbDropdown');
        
        if (!heading || !dropdown) return;
        
        const optionName = heading.textContent.trim();
        const menuItems = dropdown.querySelectorAll('.gfbDropdownMenuItem');
        const optionValues = [];
        
        menuItems.forEach(menuItem => {
          const input = menuItem.querySelector('input[type="radio"]');
          const span = menuItem.querySelector('span');
          const swatchWrapper = menuItem.querySelector('.gfbDropdownMenuItemWrapper');
          const imageEl = menuItem.querySelector('.gfbDropdownMenuItemWrapper img');
          
          if (!span) return;
          
          const valueName = span.textContent.trim();
          
          // Check if this option value is available given current selections in OTHER options
          let isAvailable = true;
          if (gfbProduct && gfbProduct.productOptions) {
            // Find the matching option in GFB product data
            const gfbOption = gfbProduct.productOptions.find(opt => opt.name === optionName);
            if (gfbOption) {
              // Get the position of this option
              const currentOptionIndex = gfbProduct.productOptions.findIndex(opt => opt.name === optionName);
              
              // Check if there's ANY available variant that matches:
              // 1. This option value
              // 2. All other currently selected option values
              isAvailable = false;
              
              // Get ALL optionValues in this option that match the valueName
              const matchingOptionValues = gfbOption.optionValues.filter(ov => ov.name === valueName);
              
              // Check if ANY of these variants is available and matches other selections
              for (const optionValue of matchingOptionValues) {
                if (!optionValue.variant || !optionValue.variant.available) continue;
                
                const variant = optionValue.variant;
                let matchesOtherSelections = true;
                
                // Check if this variant matches all OTHER currently selected options
                gfbProduct.productOptions.forEach((opt, idx) => {
                  if (idx === currentOptionIndex) return; // Skip current option
                  
                  const selectedValueForOpt = currentSelections[opt.name];
                  if (selectedValueForOpt && variant.options && variant.options[idx]) {
                    if (variant.options[idx] !== selectedValueForOpt) {
                      matchesOtherSelections = false;
                    }
                  }
                });
                
                if (matchesOtherSelections) {
                  isAvailable = true;
                  break; // Found at least one matching available variant
                }
              }
            }
          }
                    
          // Skip unavailable options
          if (!isAvailable) {
            return;
          }
          
          // Try to get color from GFB, fallback to hardcoded values
          let swatchColor = null;
          if (swatchWrapper) {
            swatchColor = swatchWrapper.style.getPropertyValue('--custom-swatch-color');
          }
          if (!swatchColor) {
            swatchColor = getHardcodedColorSwatch(valueName);
          }
          
          const swatch = {
            color: swatchColor || null,
            image: imageEl ? normalizeImageUrl(imageEl.src) : null
          };
          
          optionValues.push({
            name: valueName,
            swatch: swatch,
            isSelected: input ? input.checked : false,
            originalInput: input,
            originalMenuItem: menuItem
          });
        });
        
        options.push({
          name: optionName,
          optionValues: optionValues,
          originalDropdown: dropdown,
          originalContainer: dropdownContainer
        });
      });
      
      if (options.length > 0) {
        productsData.push({
          image: image,
          quantity: quantity,
          options: options,
          originalProduct: product,
          gfbProductData: gfbProduct // Store GFB product data with availability info
        });
      }
    });

    // Build new UI
    const container = document.createElement('div');
    container.className = 'kb-custom-ui-container';
    
    // Get locale from HTML lang attribute or default to 'en'
    const locale = document.documentElement.lang || 'en';
    
    // Translation for "SAVE"
    const saveTranslations = {
      'sl': 'POPUST',
      'hr': 'UŠTEDI',
      'cs': 'UŠETŘI',
      'pl': 'ZAOSZCZĘDŹ',
      'sk': 'UŠETRI',
      'en': 'SAVE'
    };
    const saveText = saveTranslations[locale] || saveTranslations['en'];
    
    // Add header with "Choose Options:" label and Bristle Guide button
    const optionsHeader = document.createElement('div');
    optionsHeader.className = 'kb-options-header';
    
    const chooseOptionsLabel = document.createElement('div');
    chooseOptionsLabel.className = 'kb-choose-options-label';
    const chooseOptionsTranslations = {
      'sl': 'Izberi možnosti:',
      'hr': 'Odaberi opcije:',
      'sk': 'Vyberte možnosti:',
      'cs': 'Vyberte možnosti:',
      'pl': 'Wybierz opcje:',
      'en': 'Choose Options:'
    };
    chooseOptionsLabel.textContent = chooseOptionsTranslations[locale] || chooseOptionsTranslations['en'];
    
    // Check if there are any hardness options to show the Bristle Guide button
    const hasHardnessOptions = productsData.some(p => 
      p.options.some(opt => 
        ['Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
         'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
         'Twardość włókien'].includes(opt.name)
      )
    );
    
    optionsHeader.appendChild(chooseOptionsLabel);
    
    if (hasHardnessOptions) {
      const bristleGuideText = (window.productMetafields && window.productMetafields.hardnessDescriptions && window.productMetafields.hardnessDescriptions.bristle_guide_button) || 'Bristle Guide';
      
      const infoBtn = document.createElement('button');
      infoBtn.type = 'button';
      infoBtn.className = 'kb-bristle-info-btn';
      infoBtn.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17651 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.6859 5.49207 12.0862 4.04636 11.0199 2.98009C9.95364 1.91382 8.50793 1.31409 7 1.3125ZM6.78125 3.9375C6.91105 3.9375 7.03793 3.97599 7.14584 4.0481C7.25376 4.12021 7.33788 4.2227 7.38755 4.34261C7.43722 4.46253 7.45021 4.59448 7.42489 4.72178C7.39957 4.84908 7.33707 4.96601 7.24529 5.05779C7.15351 5.14957 7.03658 5.21207 6.90928 5.23739C6.78198 5.26271 6.65003 5.24972 6.53012 5.20005C6.4102 5.15038 6.30771 5.06626 6.2356 4.95834C6.16349 4.85042 6.125 4.72354 6.125 4.59375C6.125 4.4197 6.19414 4.25278 6.31721 4.12971C6.44028 4.00664 6.6072 3.9375 6.78125 3.9375ZM7.4375 10.0625C7.20544 10.0625 6.98288 9.97031 6.81878 9.80622C6.65469 9.64212 6.5625 9.41956 6.5625 9.1875V7C6.44647 7 6.33519 6.95391 6.25314 6.87186C6.1711 6.78981 6.125 6.67853 6.125 6.5625C6.125 6.44647 6.1711 6.33519 6.25314 6.25314C6.33519 6.17109 6.44647 6.125 6.5625 6.125C6.79457 6.125 7.01713 6.21719 7.18122 6.38128C7.34531 6.54538 7.4375 6.76794 7.4375 7V9.1875C7.55353 9.1875 7.66481 9.23359 7.74686 9.31564C7.82891 9.39769 7.875 9.50897 7.875 9.625C7.875 9.74103 7.82891 9.85231 7.74686 9.93436C7.66481 10.0164 7.55353 10.0625 7.4375 10.0625Z" fill="#414042" fill-opacity="0.6"/>
        </svg>
        <span>${bristleGuideText}</span>
      `;
      
      infoBtn.addEventListener('click', () => {
        const modal = document.querySelector('.kb-bristle-modal-overlay');
        if (modal) {
          modal.classList.add('open');
        }
      });
      
      optionsHeader.appendChild(infoBtn);
    }
    
    container.appendChild(optionsHeader);
    
    const variantsGrid = document.createElement('div');
    variantsGrid.className = 'kb-variants-grid';

    productsData.forEach((productData, productIndex) => {
      const card = document.createElement('div');
      card.className = 'kb-variant-card';

      // Product image
      const kbImage = document.createElement('img');
      kbImage.className = 'kb-variant-image';
      kbImage.src = productData.image || '';
      kbImage.alt = `Product ${productIndex + 1}`;
      kbImage.loading = 'lazy';
      card.appendChild(kbImage);

      // Selectors row
      const selectorsRow = document.createElement('div');
      selectorsRow.className = 'kb-selectors-row';

      productData.options.forEach((option, optionIndex) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'kb-option-wrapper';
        const isFirstOption = optionIndex === 0; // Only first option should update image

        const optionLabel = document.createElement('div');
        optionLabel.className = 'kb-option-label';
        optionLabel.textContent = option.name;
        wrapper.appendChild(optionLabel);

        const triggerButton = document.createElement('button');
        triggerButton.type = 'button';
        triggerButton.className = 'kb-trigger-button';

        const leftGroup = document.createElement('div');
        leftGroup.className = 'kb-trigger-left';

        const valueDisplay = document.createElement('span');
        valueDisplay.className = 'kb-value-display';
        leftGroup.appendChild(valueDisplay);
        
        const swatchDisplay = document.createElement('span');
        swatchDisplay.className = 'kb-swatch-display';
        leftGroup.appendChild(swatchDisplay);

        triggerButton.appendChild(leftGroup);

        const caret = document.createElement('span');
        caret.className = 'kb-caret';
        caret.innerHTML = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 13.5L15.5 18.5L10.5 13.5" stroke="#414042" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        triggerButton.appendChild(caret);

        const dropdown = document.createElement('div');
        dropdown.className = 'kb-dropdown';

        const colorOptionNames = ['Colour', 'Color', 'Boja', 'Barva', 'Kolor', 'Farba'];
        const isColorOption = colorOptionNames.includes(option.name);
        
        const hardnessOptionNames = [
          'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
          'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
          'Twardość włókien'
        ];
        const isHardnessOption = hardnessOptionNames.includes(option.name);
        
        const activeIngredientNames = [
          'Active ingredient', 'Active ingredient ', 
          'Aktivni sastojak', 'Aktivna sestavina', 'Aktywny składnik', 
          'Aktivní složka', 'Aktívna zložka', 'Składnik aktywny'
        ];
        const isActiveIngredientOption = activeIngredientNames.includes(option.name);

        if (isHardnessOption || isActiveIngredientOption) {
          dropdown.classList.add('kb-dropdown-hardness-option');
        }

        // Find the selected value, or default to first available option
        let selectedValue = option.optionValues.find(v => v.isSelected)?.name || option.optionValues[0]?.name || '';
        
        // If no options are available, skip this option entirely
        if (option.optionValues.length === 0) return;

        const updateTriggerDisplay = (valueName) => {
          const optVal = option.optionValues.find((val) => val.name === valueName);
          if (!optVal) return;

          // Handle color swatches - prioritize color over image for swatch display
          if (optVal.swatch && optVal.swatch.color) {
            swatchDisplay.classList.add('visible');
            swatchDisplay.classList.remove('has-image');
            swatchDisplay.style.background = optVal.swatch.color;
          } else if (optVal.swatch && optVal.swatch.image) {
            swatchDisplay.classList.add('visible', 'has-image');
            swatchDisplay.style.background = `url(${optVal.swatch.image}) center/cover`;
          } else {
            swatchDisplay.classList.remove('visible', 'has-image');
          }

          // Build display text with optional quantity prefix
          let displayText = '';
          if (productData.quantity) {
            displayText = `${productData.quantity}x `;
          }

          // Handle active ingredient text formatting
          if (isActiveIngredientOption && optVal.name.includes(' / ')) {
            const parts = optVal.name.split(' / ');
            valueDisplay.innerHTML = displayText + `<span class="kb-ingredient-bold">${parts[0]}</span> / <span class="kb-ingredient-normal">${parts[1]}</span>`;
          } else {
            valueDisplay.textContent = displayText + optVal.name;
          }

          // Handle hardness badge in trigger
          const existingBadge = leftGroup.querySelector('.kb-hardness-badge-trigger');
          if (existingBadge) {
            existingBadge.remove();
          }

          if (isHardnessOption) {
            const bristleHardnessValue = getHardnessBadge(optVal.name);
            if (bristleHardnessValue) {
              const triggerBadge = document.createElement('span');
              triggerBadge.className = 'kb-hardness-badge-trigger';
              triggerBadge.textContent = bristleHardnessValue;
              leftGroup.appendChild(triggerBadge);
            }
          }
        };

        const setSelectedValue = (valueName) => {
          selectedValue = valueName;
          updateTriggerDisplay(valueName);
          dropdown.querySelectorAll('[data-option-value]').forEach((node) => {
            if (node.dataset.optionValue === valueName) {
              node.classList.add('selected');
            } else {
              node.classList.remove('selected');
            }
          });
        };

        triggerButton.addEventListener('click', (event) => {
          event.stopPropagation();
          const wasOpen = dropdown.classList.contains('open');
          
          wrapper.querySelectorAll('.kb-dropdown').forEach((dd) => {
            if (dd !== dropdown) {
              dd.classList.remove('open');
            }
          });
          
          if (wasOpen) {
            dropdown.classList.remove('open');
          } else {
            dropdown.classList.add('open');
          }
        });

        option.optionValues.forEach((optVal) => {
          const optionRow = document.createElement('button');
          optionRow.type = 'button';
          optionRow.className = 'kb-option-row';
          optionRow.dataset.optionValue = optVal.name;

          const rowWrapper = document.createElement('div');
          rowWrapper.className = 'kb-option-row-wrapper';

          // For hardness options, show special badge layout
          if (isHardnessOption) {
            const hardnessContainer = document.createElement('div');
            hardnessContainer.className = 'kb-hardness-row';
            
            const valueName = document.createElement('div');
            valueName.className = 'kb-hardness-value';
            valueName.textContent = (productData.quantity ? `${productData.quantity}x ` : '') + optVal.name;
            hardnessContainer.appendChild(valueName);

            const bristleHardnessValue = getHardnessBadge(optVal.name);
            if (bristleHardnessValue) {
              const badge = document.createElement('span');
              badge.className = 'kb-hardness-badge';
              badge.textContent = bristleHardnessValue;
              hardnessContainer.appendChild(badge);
            }
            
            rowWrapper.appendChild(hardnessContainer);
          }
          // For active ingredient options, show formatted text
          else if (isActiveIngredientOption) {
            const ingredientContainer = document.createElement('div');
            ingredientContainer.className = 'kb-hardness-row';
            
            const valueName = document.createElement('div');
            valueName.className = 'kb-hardness-value';
            
            const qtyPrefix = productData.quantity ? `${productData.quantity}x ` : '';
            
            if (optVal.name.includes(' / ')) {
              const parts = optVal.name.split(' / ');
              valueName.innerHTML = qtyPrefix + `<span class="kb-ingredient-bold">${parts[0]}</span> / <span class="kb-ingredient-normal">${parts[1]}</span>`;
            } else {
              valueName.textContent = qtyPrefix + optVal.name;
            }
            
            ingredientContainer.appendChild(valueName);
            rowWrapper.appendChild(ingredientContainer);
          }
          // For color options, show color swatch or image
          else if (isColorOption) {
            // Show image preview if available
            if (optVal.swatch && optVal.swatch.image) {
              const preview = document.createElement('img');
              preview.className = 'kb-option-preview';
              preview.src = optVal.swatch.image;
              preview.alt = optVal.name;
              preview.loading = 'lazy';
              rowWrapper.appendChild(preview);
            }

            const detailColumn = document.createElement('div');
            detailColumn.className = 'kb-option-detail';

            if (optVal.swatch && optVal.swatch.color) {
              const rowSwatch = document.createElement('span');
              rowSwatch.className = 'kb-row-swatch';
              rowSwatch.style.background = optVal.swatch.color;
              detailColumn.appendChild(rowSwatch);
            }

            const rowLabel = document.createElement('span');
            rowLabel.className = 'kb-row-label';
            rowLabel.textContent = (productData.quantity ? `${productData.quantity}x ` : '') + optVal.name;
            detailColumn.appendChild(rowLabel);
            
            rowWrapper.appendChild(detailColumn);
          }
          // Default rendering for other options
          else {
            const detailColumn = document.createElement('div');
            detailColumn.className = 'kb-option-detail';
            
            const rowLabel = document.createElement('span');
            rowLabel.className = 'kb-row-label';
            rowLabel.textContent = (productData.quantity ? `${productData.quantity}x ` : '') + optVal.name;
            detailColumn.appendChild(rowLabel);
            
            rowWrapper.appendChild(detailColumn);
          }

          optionRow.appendChild(rowWrapper);

          optionRow.addEventListener('click', (event) => {
            event.stopPropagation();
            if (optVal.name === selectedValue) {
              dropdown.classList.remove('open');
              return;
            }

            setSelectedValue(optVal.name);
            dropdown.classList.remove('open');

            // Trigger original GFB menu item click
            if (optVal.originalMenuItem) {
              optVal.originalMenuItem.click();
            } else if (optVal.originalInput) {
              optVal.originalInput.checked = true;
              optVal.originalInput.dispatchEvent(new Event('change', { bubbles: true }));
              optVal.originalInput.dispatchEvent(new Event('click', { bubbles: true }));
            }

            // Update product image ONLY if this is the first option (e.g., color)
            if (isFirstOption) {
              setTimeout(() => {
                const kbImageInCard = card.querySelector('.kb-variant-image');
                if (kbImageInCard) {
                  // First try to use the option's swatch image
                  if (optVal.swatch && optVal.swatch.image) {
                    kbImageInCard.src = optVal.swatch.image;
                  } else {
                    // Fallback to GFB's updated image
                    const originalImage = productData.originalProduct.querySelector('.gfbFrequentBoughtWidgetProductImageEle');
                    if (originalImage && originalImage.src) {
                      kbImageInCard.src = normalizeImageUrl(originalImage.src);
                    }
                  }
                }
              }, 50);
            }
            
            // Rebuild the UI after a short delay to update dropdown options based on new selection
            // Use debounce to prevent multiple rapid rebuilds
            if (rebuildTimeout) {
              clearTimeout(rebuildTimeout);
            }
            rebuildTimeout = setTimeout(() => {
              const wrapperToRebuild = document.querySelector('.gfbPageWrapper .gfbFrequentBoughtWrapper');
              if (wrapperToRebuild && !isRebuilding) {
                // Remove the redesigned flag so it rebuilds
                delete wrapperToRebuild.dataset.gfbRedesigned;
                // Rebuild
                redesignGFBBundles();
              }
              rebuildTimeout = null;
            }, 150);
          });

          dropdown.appendChild(optionRow);
        });

        wrapper.appendChild(triggerButton);
        wrapper.appendChild(dropdown);

        setSelectedValue(selectedValue);

        selectorsRow.appendChild(wrapper);
      });

      card.appendChild(selectorsRow);
      variantsGrid.appendChild(card);
    });

    if (window.blackFridayBadge && window.blackFridayBadge.enabled === 'true' && USE_V2_BADGE) {
      // v2: dark badge above the variants grid
      const bfBadgeTop = document.createElement('div');
      bfBadgeTop.className = 'kb-black-friday-badge-top';

      const topText1 = document.createElement('span');
      topText1.className = 'kb-bf-text-1';
      topText1.textContent = window.blackFridayBadge.v2_text_above_1 || '';

      const topText2 = document.createElement('span');
      topText2.className = 'kb-bf-text-2';
      topText2.textContent = window.blackFridayBadge.v2_text_above_2 || '';

      bfBadgeTop.appendChild(topText1);
      bfBadgeTop.appendChild(topText2);
      container.insertBefore(bfBadgeTop, optionsHeader);
    }

    container.appendChild(variantsGrid);

    if (window.blackFridayBadge && window.blackFridayBadge.enabled === 'true') {
      if (USE_V2_BADGE) {
        // v2: purple badge below the variants grid (discount % injected at render time)
        const bfBadgeBottom = document.createElement('div');
        bfBadgeBottom.className = 'kb-black-friday-badge';

        const bottomText1 = document.createElement('span');
        bottomText1.className = 'kb-bf-text-2';
        const discountPct = getRoundedDiscountPercent(window.ProductPricing);
        const underLabel1 = window.blackFridayBadge.v2_text_under_1 || '';
        bottomText1.textContent = discountPct > 0 ? `${underLabel1} ${discountPct}%` : underLabel1;

        const bottomText2 = document.createElement('span');
        bottomText2.className = 'kb-bf-text-1';
        const hasFreeShipping = window.has_free_shipping === true || window.has_free_shipping === 'true' || window.has_free_shipping === 1 || window.has_free_shipping === '1';
        bottomText2.textContent = hasFreeShipping ? (window.blackFridayBadge.v2_text_under_2 || '') : '';

        bfBadgeBottom.appendChild(bottomText1);
        if (bottomText2.textContent) {
          bfBadgeBottom.appendChild(bottomText2);
        }
        container.appendChild(bfBadgeBottom);
      } else {
        // v1: original single badge
        const bfBadge = document.createElement('div');
        bfBadge.className = 'kb-black-friday-badge';

        const text1 = document.createElement('span');
        text1.className = 'kb-bf-text-1';
        text1.textContent = window.blackFridayBadge.text_1 || '';

        const text2 = document.createElement('span');
        text2.className = 'kb-bf-text-2';
        text2.textContent = window.blackFridayBadge.text_2 || '';

        bfBadge.appendChild(text1);
        bfBadge.appendChild(text2);
        container.appendChild(bfBadge);
      }
    }

    // Add price section
    const priceSection = document.createElement('div');
    priceSection.className = 'kb-price-section';
    
    const priceLabel = document.createElement('div');
    priceLabel.className = 'kb-price-label';
    priceLabel.textContent = 'Total price';
    
    const priceValues = document.createElement('div');
    priceValues.className = 'kb-price-values';
    
    const priceCurrent = document.createElement('div');
    priceCurrent.className = 'kb-price-current';
    
    const priceCompare = document.createElement('div');
    priceCompare.className = 'kb-price-compare';
    
    const priceDiscount = USE_V2_BADGE ? null : document.createElement('div');
    if (priceDiscount) priceDiscount.className = 'kb-price-discount';
    
    // Function to calculate and update prices from window.ProductPricing
    const updatePrices = () => {
      if (window.ProductPricing) {
        const currentPrice = window.ProductPricing.price || '';
        const comparePrice = window.ProductPricing.compare_at_price || '';
        const discountPercentage = getRoundedDiscountPercent(window.ProductPricing);
        
        priceCurrent.textContent = currentPrice;
        
        if (comparePrice && comparePrice !== currentPrice) {
          priceCompare.textContent = comparePrice;
          priceCompare.style.display = 'block';
        } else {
          priceCompare.style.display = 'none';
        }
        
        if (priceDiscount) {
          if (discountPercentage > 0) {
            let discountText = `${saveText} ${discountPercentage}%`;
            
            // Add free shipping text if available
            if (window.has_free_shipping && window.has_free_shipping_text) {
              discountText += ` <span style="color: #00EBBE;">${window.has_free_shipping_text}</span>`;
            }
            
            priceDiscount.innerHTML = discountText;
            priceDiscount.style.display = 'block';
          } else {
            priceDiscount.style.display = 'none';
          }
        }
      }
    };
    
    // Initial price update
    updatePrices();
    
    priceValues.appendChild(priceCurrent);
    priceValues.appendChild(priceCompare);
    priceValues.appendChild(priceCurrent);
    if (priceDiscount) priceValues.appendChild(priceDiscount);
    
    priceSection.appendChild(priceLabel);
    priceSection.appendChild(priceValues);
    
    container.appendChild(priceSection);

    // Insert new UI before the original content
    const contentContainer = wrapper.querySelector('.gfbFrequentBoughtReplacableContent');
    if (contentContainer && contentContainer.parentNode) {
      contentContainer.parentNode.insertBefore(container, contentContainer);
    }

    // Create bristle hardness modal if needed
    const hardnessOptionNames = [
      'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
      'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
      'Twardość włókien'
    ];
    const hasHardnessOption = productsData.some(p => 
      p.options.some(opt => hardnessOptionNames.includes(opt.name))
    );
    
    if (hasHardnessOption && !document.querySelector('.kb-bristle-modal-overlay')) {
      const modalOverlay = document.createElement('div');
      modalOverlay.className = 'kb-bristle-modal-overlay';
      
      const modal = document.createElement('div');
      modal.className = 'kb-bristle-modal';
      
      // Get descriptions from window.productMetafields or fallback to English
      const fallbackDesc = {
        soft: 'Perfect for those with sensitive teeth and gums. Our softest option ensures a gentle, soothing clean without irritation',
        soft_tag: 'GENTLE',
        soft_name: 'Soft',
        medium: 'Our most popular and recommended option, optimized for balance, comfort, and plaque control',
        medium_tag: 'JUST RIGHT',
        medium_name: 'Medium',
        hard: 'Ideal for polishing and a thorough clean. Not as harsh as traditional hard brushes, but best suited for those without sensitive gums',
        hard_tag: 'INTENSE',
        hard_name: 'Hard',
        bristle_guide_title: 'Bristle<br/>Hardness Guide'
      };
      
      const hardnessDesc = (window.productMetafields && window.productMetafields.hardnessDescriptions) || fallbackDesc;
      const softDesc = hardnessDesc.soft || fallbackDesc.soft;
      const softTag = hardnessDesc.soft_tag || fallbackDesc.soft_tag;
      const softName = hardnessDesc.soft_name || fallbackDesc.soft_name;
      const mediumDesc = hardnessDesc.medium || fallbackDesc.medium;
      const mediumTag = hardnessDesc.medium_tag || fallbackDesc.medium_tag;
      const mediumName = hardnessDesc.medium_name || fallbackDesc.medium_name;
      const hardDesc = hardnessDesc.hard || fallbackDesc.hard;
      const hardTag = hardnessDesc.hard_tag || fallbackDesc.hard_tag;
      const hardName = hardnessDesc.hard_name || fallbackDesc.hard_name;
      const modalTitle = hardnessDesc.bristle_guide_title || fallbackDesc.bristle_guide_title;
      
      modal.innerHTML = `
        <div class="kb-bristle-modal-header">
          <div class="kb-bristle-modal-title">${modalTitle}</div>
          <button class="kb-bristle-modal-close" type="button">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 12L12 20" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 12L20 20" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          </button>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${softName}</div>
          <div class="kb-bristle-option-badge">${softTag}</div>
          <div class="kb-bristle-option-description">${softDesc}</div>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${mediumName}</div>
          <div class="kb-bristle-option-badge">${mediumTag}</div>
          <div class="kb-bristle-option-description">${mediumDesc}</div>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${hardName}</div>
          <div class="kb-bristle-option-badge">${hardTag}</div>
          <div class="kb-bristle-option-description">${hardDesc}</div>
        </div>
      `;
      
      modalOverlay.appendChild(modal);
      document.body.appendChild(modalOverlay);
      
      // Close modal handlers
      const closeBtn = modal.querySelector('.kb-bristle-modal-close');
      closeBtn.addEventListener('click', () => {
        modalOverlay.classList.remove('open');
      });
      
      modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
          modalOverlay.classList.remove('open');
        }
      });
    }

    // Localize add to cart button
    const button = wrapper.querySelector('.gfbFrequentBoughtAddToCartButton');
    if (button) {
      const addToCartTranslations = {
        'sl': 'Dodaj v košarico',
        'hr': 'Dodaj u košaricu',
        'pl': 'Dodaj do koszyka',
        'cs': 'Přidat do košíku',
        'sk': 'Pridať do košíka',
        'en': 'Add to cart'
      };
      
      const outOfStockTranslations = {
        'sl': 'Ni na zalogi',
        'hr': 'Nema na zalihi',
        'pl': 'Brak w magazynie',
        'cs': 'Není skladem',
        'sk': 'Nie je skladom',
        'en': 'Out of stock'
      };
      
      const localizeButton = () => {
        const currentText = button.textContent.trim().toLowerCase();
        
        if (currentText.includes('add to cart')) {
          button.textContent = addToCartTranslations[locale] || addToCartTranslations['en'];
        } else if (currentText.includes('out of stock')) {
          button.textContent = outOfStockTranslations[locale] || outOfStockTranslations['en'];
        }
      };
      
      localizeButton();
      
      // Watch for button text changes
      let isLocalizing = false;
      const buttonObserver = new MutationObserver(() => {
        if (!isLocalizing) {
          isLocalizing = true;
          localizeButton();
          setTimeout(() => { isLocalizing = false; }, 100);
        }
      });
      buttonObserver.observe(button, { childList: true, characterData: true, subtree: true });
    }

    wrapper.dataset.gfbRedesigned = 'true';
    
    // Fade in ALL page wrappers after redesign is complete
    allPageWrappers.forEach(pageWrapper => {
      pageWrapper.style.display = 'block';
      requestAnimationFrame(() => {
        pageWrapper.classList.add('gfb-ready');
      });
    });
    
    // Allow future rebuilds
    isRebuilding = false;
  }

  function init() {
    const checkInterval = setInterval(() => {
      const wrapper = document.querySelector('.gfbPageWrapper .gfbFrequentBoughtWrapper');
      if (wrapper) {
        clearInterval(checkInterval);
        
        setTimeout(() => {
          redesignGFBBundles();
        }, 800);
        
        // Watch for changes
        const observer = new MutationObserver(() => {
          const needsRedesign = wrapper.dataset.gfbRedesigned !== 'true';
          if (needsRedesign) {
            redesignGFBBundles();
          }
        });
        observer.observe(wrapper, { childList: true, subtree: true, attributes: true });
      }
    }, 100);
    
    // Fallback: show all wrappers after timeout even if redesign doesn't complete
    setTimeout(() => {
      clearInterval(checkInterval);
      const allPageWrappers = document.querySelectorAll('.gfbPageWrapper');
      allPageWrappers.forEach(pageWrapper => {
        if (!pageWrapper.classList.contains('gfb-ready')) {
          pageWrapper.style.display = 'block';
          requestAnimationFrame(() => {
            pageWrapper.classList.add('gfb-ready');
          });
        }
      });
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
